module.exports = __webpack_public_path__ + "static/media/212-moldova.0116e6bc.svg";